module.exports = __webpack_public_path__ + "img/application.13ea113b.svg";